import { css } from 'styled-components/macro';

export const AccordionHeaderStyle = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  width: 100%;
  background-color: #f7f7f7;
  padding-left: 16px;
  padding-right: 16px;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  color: #2e4063;
  cursor: pointer;
  user-select: none;
  z-index: 1000;
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
`;

export const AccordionStyle = css`
  overflow: hidden;
  position: relative;
  margin-bottom: 22px;
  box-shadow: 0px 1px 14px rgba(0, 0, 0, 0.12);
`;

export const AccordionContentStyle = css`
  padding: 16px;

  a {
    text-decoration: underline;
  }
`;
